import { render, staticRenderFns } from "./test1.vue?vue&type=template&id=6d5fa6bc&scoped=true&"
import script from "./test1.vue?vue&type=script&lang=js&"
export * from "./test1.vue?vue&type=script&lang=js&"
import style0 from "./test1.vue?vue&type=style&index=0&id=6d5fa6bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5fa6bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d5fa6bc')) {
      api.createRecord('6d5fa6bc', component.options)
    } else {
      api.reload('6d5fa6bc', component.options)
    }
    module.hot.accept("./test1.vue?vue&type=template&id=6d5fa6bc&scoped=true&", function () {
      api.rerender('6d5fa6bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/test1.vue"
export default component.exports